import { Component, OnInit } from '@angular/core';
import { EventService } from '../../services/event.service';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css']
})
export class EventsComponent implements OnInit {
  public events = [];

  constructor(protected eventService: EventService) {
    this.load();
  }

  ngOnInit() {
  }

  protected load() {
    this.eventService.index().subscribe(events => {
      this.events = events;
      console.log(this.events);
    });
  }

  public delete(event) {
    this.eventService.destroy(event).subscribe(() => this.load());
  }
}



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/components/events/events.component.ts